'use client'
import { useNavigation } from '@/lib/context/navigationcontext'
import React, { ReactNode, useEffect } from 'react'
import { Box, Stack } from '@mui/material'
import { Sizes } from '@/lib/constants/sizes'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/navigation'
import Navbar from './navbar'
import LeftNav from './leftnav'

interface NavContainerProps {
	readonly children: ReactNode
}

export default function NavContainer({ children }: NavContainerProps) {
	const { data: session } = useSession()
	const router = useRouter()
	const { showLeftNav, showTopNav, isLeftNavExpanded } = useNavigation()

	useEffect(() => {
		if (session === null) {
			router.push('/')
		}
	}, [router, session])

	return (
		<Stack sx={{ minHeight: '100vh' }}>
			<>
				{showTopNav === true && <Navbar />}
				{showLeftNav === true && <LeftNav />}
				<Box
					sx={{
						marginTop: showTopNav ? `${Sizes.TOP_NAV_HEIGHT}px` : 0,
						marginLeft: {
							xs: 0,
							sm: (() => {
								if (!showLeftNav) return 0
								return isLeftNavExpanded
									? `${Sizes.LEFT_DRAWER_WIDTH}px`
									: `${Sizes.LEFT_DRAWER_COLLAPSE_WIDTH}px`
							})(),
						},
						pb: 1,
						mb: 0,
						flexGrow: 1,
						display: 'flex',
						flexDirection: 'column',
					}}
					data-testid="nav-container"
				>
					{children}
				</Box>
			</>
		</Stack>
	)
}
